import React from 'react';
// react-bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Spinner from 'react-bootstrap/Spinner';
// components
import SearchBar from '../SearchBar';
import Book from '../BookItem';
// hooks
import { useSearchBooks } from '../Hooks/useSearchBooks';
// image
import NoBooksImage from '../../images/no_results_image.svg';

const SearchPage = () => {
  const { state, loading, error, searchBooks } = useSearchBooks();

  const handleSearch = (title, author) => {
    searchBooks(title, author);
  };

  return (
    <Container className={'py-5 px-5'}>
      <h3 className='text-center'>Search by title or author or both</h3>
      <SearchBar callback={handleSearch} searchParams={state.searchParams} />
      {loading && (
        <div className={'my-3 text-center'}>
          <Spinner animation='border' variant='primary' />
        </div>
      )}
      {state.total_results > 0 && (
        <Row className='mt-3'>
          {state.books_list.map((book) => (
            <Col
              xs={6}
              md={4}
              lg={2}
              className={'text-center p-3'}
              key={book._id}
            >
              <Book book={book} source={'discover'} />
            </Col>
          ))}
        </Row>
      )}
      {error && (
        <div className='mt-5 text-center'>
          <h2 className='mt-5' style={{ color: 'red' }}>
            {error}
          </h2>
          <Image src={NoBooksImage} fluid />
        </div>
      )}
    </Container>
  );
};

export default SearchPage;
